export function resizeModeToMediaImageProps(resizeMode) {
  return {
    crop: resizeMode === 'crop',
    stretch: resizeMode === 'stretchy-fit'
  };
}